
// src/connects/diary-forms-base.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import uploadFiles from '../helpers/file-upload'
import actions from '../actions'
import { validate } from '../helpers/form-validator'
import map from 'lodash/map'
import filter from 'lodash/filter'
import each from 'lodash/each'
import some from 'lodash/some'
import _ from 'lodash'
import moment from 'moment'
import { pushRoute } from '../actions/route'
import isGoogleDocUrl from '../helpers/google-doc'
import isGambaUrl from '../helpers/gamba-url'
import { urlRegex } from '../helpers/url-regexp'
import componentId from '../helpers/component-id'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import windowFocus from '../helpers/window-focus'
import { translate } from 'react-i18next'
import { trackHandlers } from '../helpers/analytics'
import isUploadedFilesChanged from '../helpers/uploaded-files-changed'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'

const EMPTY_HASH = {}
const UrlRegex = urlRegex()
const MAX_FIELD_TEXT_LEN = 2 * 1024

export const mapStateToProps = (state, ownProps)=> {
  return {
    user: state.user.current,
    isPosting: state.diaries.isPosting,
    isPostFailed: state.diaries.isPostFailed,
    isSaving: state.savedDiaries.isPosting,
    isSaveFailed: state.savedDiaries.isPostFailed,
    uploadedFiles: state.uploadFile[ownProps.componentId] || EMPTY_HASH,
    uploadedVideos: state.uploadVideo[ownProps.componentId] || EMPTY_HASH,
    current: state.savedDiaries.current,
    templates: state.diaryTemplates.items,
    savedDiaries: state.savedDiaries.items,
    insertHTML: state.diaryForm.insert && state.diaryForm.insert.html,
    kpi: state.diaryKPI.items,
    rightSidePageIsGoogleCalendar: state.rightSidePage.name == 'google_calendar',
    rightSidePageIsCreateDiary: state.rightSidePage.name == 'create_diary',
    isPhone: state.media.isPhone,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    socketStatus: state.socket.status,
    urlInfo: state.urlInfo[ownProps.componentId],
    isEditDiaryFetching: state.editDiary.isFetching,
		group: ownProps.group,
    review: state.lambdaApi.stream,
    isFetching: state.lambdaApi.isFetching,
    isFetchFailed: state.lambdaApi.isFetchFailed,
    isOpenReviewPanel: state.lambdaApi.isOpenReviewPanel,
    isReviewCompleted: state.lambdaApi.isCompleted,
    isReviewEnable: state.reviewSetting.isEnable
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var isUploading
  each(stateProps.uploadedFiles, (value, key)=> {
    value && value.isUploading && (isUploading = true)
  })
  each(stateProps.uploadedVideos, (value, key)=> {
    value && value.isUploading && (isUploading = true)
  })
  var templateActions = [{
    name: 'user_templates_setting',
    callback: () => dispatchProps.showUserTemplatesSetting()
  }]
  if (ownProps.group.is_admin)
    templateActions.push({
      name: 'group_templates_setting',
      callback: () => dispatchProps.showGroupTemplatesSetting()
    })

  return {
    blinkEditForm: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.submitDiary != 'hide'),
    templateActions,
    isUploading,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

function normalizeFields(fields) {
  if (!fields) return undefined
  return map(fields, (field)=> {
    field = Object.assign({}, field)
    if (field.type == 'date') // dateの場合は日付の書式に整形
      field.value = field.value && moment(field.value).format('YYYY-MM-DD') || undefined
    if (field.type == 'numeric') // numericの場合は実数に変換
      field.value = parseFloat(field.value)
    return field
  })
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  const onChangeEditor = _.debounce((props) => {
    if (!props.isPosting && !props.isSaving && props.ui.hasFocus && props.socketStatus == 'connected' && props.ui.editorHandlers) {
      props.ui.editorHandlers.getValue((content) => {
        var files = map(filter(props.uploadedFiles, (file) => file && file.item), (file) => file.item.file_id)
        var videos = map(filter(props.uploadedVideos, (file) => file && file.item), (file) => file.item.video_id)
        var mentions = map(props.ui.mentions, (mention)=> mention.user_id)
        var attach_json = {
          links: props.ui.urlLinks,
          fields: normalizeFields(props.ui.fields),
        }

        if (props.ui.category == 'kpi' && props.kpi && props.kpi.length > 0) {
          attach_json.kpi_status = props.kpi.map((item) => Object.assign({}, item, {
            actual: isNaN(parseFloat(props.ui.values[item.kpi_id])) ? undefined : parseFloat(props.ui.values[item.kpi_id]),
            total: typeof item.total == 'undefined' ? undefined : parseFloat(props.ui.total_values[item.kpi_id])
          }))
          if (!content || content.length == 0)
            content = '<div></div>'
        }

        if (props.ui.fields && props.ui.fields.length > 0 && (!content || content.length == 0))
          content = '<div></div>'

        if (content && content.length > 0 && (!props.current || props.current && props.current.status != 'committed')){
          // 一時保存
          dispatch(actions.saveDiary(
            props.group.group_id,
            props.current && props.current.diary_id,
            props.ui.category,
            props.ui.reported_at,
            props.ui.subject,
            content,
            files,
            videos,
            attach_json && JSON.stringify(attach_json) || undefined,
            mentions
          ))
        }
      })
    }
  }, 1500)

  return {
    validateAndSubmit: (props, event = undefined) => {
      event && event.preventDefault && event.preventDefault()
      onChangeEditor.cancel() // onChangeEditorのdebounce実行をキャンセルする
      props.blinkEditForm && dispatch(actions.hideProductTour('submitDiary'))
      props.ui.editorHandlers && props.ui.editorHandlers.getValue((content) => {
        var files = filter(map(props.uploadedFiles, (file) => file && file.item && file.item.file_id), (file)=> file)
        var videos = filter(map(props.uploadedVideos, (file) => file && file.item && file.item.video_id), (file)=> file)
        var mentions = map(props.ui.mentions, (mention)=> mention.user_id)
        var attach_json = {
          links: props.ui.urlLinks,
          fields: normalizeFields(props.ui.fields),
        }
        var rules = {}

        if (props.ui.category == 'kpi' && props.kpi && props.kpi.length > 0) {
          attach_json.kpi_status = props.kpi.map((item) => Object.assign({}, item, {
            actual: isNaN(parseFloat(props.ui.values[item.kpi_id])) ? undefined : parseFloat(props.ui.values[item.kpi_id]),
            total: typeof item.total == 'undefined' ? undefined : parseFloat(props.ui.total_values[item.kpi_id])
          }))
          if (!content || content.length == 0)
            content = '<div></div>'
        }

        if (props.ui.fields && props.ui.fields.length > 0) {
          each(props.ui.fields, (item, index)=> {
            if (item.required)
              rules[`fields.${index}.value`] = { rule: 'isRequired' }
          })
          if (!content || content.length == 0)
            content = '<div></div>'
        }
        if (props.ui.category == 'memo')
          rules.subject = { rule: 'isRequired' }
        if (props.ui.category == 'kpi') {
          each(props.kpi, (item) => {
            rules[`values.${item.kpi_id}`] = { rule: 'isNumber' };
            rules[`total_values.${item.kpi_id}`] = { rule: 'isNumber' };
          })
        }

        validate(props.ui, rules, (errors, errorState) => {
          if (!content || content.length == 0) {
            errors = true
            errorState.contentError = true
          }
          if (errorState.fields) {
            let fields = props.ui.fields.concat()
            each(errorState.fields, (state, key)=> fields[key] = state)
            errorState.fields = fields
          }
          props.updateUI(errorState)

          if (!errors)
            // 投稿
            dispatch(actions.postOrUpdateDiary(
              props.group.group_id,
              props.current && props.current.diary_id,
              props.ui.category,
              props.ui.category == 'memo' ? new Date() : props.ui.reported_at,
              props.ui.category == 'memo' ? props.ui.subject : undefined,
              content,
              files,
              videos,
              attach_json && JSON.stringify(attach_json) || undefined,
              mentions
            ))
        })
      })
    },

    uploadFiles: (files)=> uploadFiles(files, dispatch, ownProps.group.group_id, 'group', ownProps.componentId),

    onChangeEditor: onChangeEditor,

    onAddLink: (props, link)=> {
      if (isGoogleDocUrl(link)) {
        if (props.ui.gapiReady)
          dispatch(actions.fetchGoogleDriveFile(link, props.componentId))
        else
          props.updateUI({ confirmGapi: true, link })
      }
      else
        dispatch(actions.fetchUrlInfo(link, props.componentId))
    },

    onDeleteLink: (props, link)=> {
      let urlLinks = Object.assign({}, props.ui.urlLinks)
      delete urlLinks[link]
      props.updateUI({ urlLinks })
    },

    onCancelConfirmGapi: (props)=> props.updateUI({ confirmGapi: false }),
    onSuccessConfirmGapi: (props)=> props.updateUI({ confirmGapi: false, gapiReady: true }),

    // windowにフォーカスが当たった際、日付が変わっていれば更新する
    onWindowFocus: (props)=> {
      dispatch(actions.fetchSavedDiaries(ownProps.group.group_id, props.user.user_id))
      if (!props.current && !moment().isSame(props.ui.reported_at, 'day'))
        props.updateUI({ reported_at: new Date() })
    },

    onUpdateField: (props, index, value)=> {
      // props.ui.fields[index].value の値を value に更新する
      // fieldのオブジェクトを複製して、value を入れ替えて、
      // props.ui.fields[index] の中身を差し替えた配列を fields に作成する
      const field = Object.assign({}, props.ui.fields[index])
      // 文字列の長さが MAX_FIELD_TEXT_LEN 以上の場合は後ろを切り捨てる
      if (value && value.toString().length > MAX_FIELD_TEXT_LEN && (field.type == 'text' || field.type == 'string'))
        value = value.toString().slice(0, MAX_FIELD_TEXT_LEN)
      if (value && field.type == 'numeric')
        value = value.toString().replace(/[^-0-9.]/g, '')
      field.value = value
      const fields = props.ui.fields.map((f, i)=> i == index ? field : f)
      // 必須入力のfieldが未入力エラーになっている場合、
      // props.ui.fields['0.valueError'] = true のように格納されているため
      // この状態を先の fields 配列に反映する
      each(filter(Object.keys(props.ui.fields), (key)=> {
        const _keys = key.split('.')
        return _keys[1] == 'valueError' && _keys[0] + 0 != index
      }), (key)=> {
        const _key = key.split('.')
        var item = fields[+_key[0]]
        if(item.required && (!item.value || item.value.length == 0)) {
          fields[key] = true
        } else {
          fields[key] = false
        }
      })
      props.updateUI({ fields })
    },

    willMount: (props)=> {
      props.updateUI({ reported_at: new Date })
      if(ownProps.group && props.user){
        dispatch(actions.fetchDiaryTemplates(ownProps.group.group_id, props.user.user_id))
        dispatch(actions.fetchSavedDiaries(ownProps.group.group_id, props.user.user_id))
      }
      ownProps.group && dispatch(actions.fetchDiaryKpi(ownProps.group.group_id, new Date()))
    },

    willUnmount: (props)=> {
      dispatch(actions.clearSavedDiary())
      dispatch(actions.clearUploadFilesAndVideos(ownProps.componentId))
    },

    willUpdate: (props, nextProps)=> {
      // 投稿処理が完了 / 編集が取り消された
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed ||
          props.ui.hasFocus && !nextProps.ui.hasFocus ||
          props.current && !nextProps.current ||
          props.group.group_id != nextProps.group.group_id) {
        if(props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed){
          if(props.current && props.current.status == 'committed' ){
            dispatch(emitAlertMessage({ message: 'label:投稿の編集が完了しました' }, 'postSuccess'))
          }else{
            dispatch(emitAlertMessage({ message: `diary:${props.ui.category}を投稿` }, 'postSuccess'))
          }
        }

        if (nextProps.ui.editorHandlers) nextProps.ui.editorHandlers.clearValue()
        nextProps.updateUI({
          subject: '',
          reported_at: new Date(),
          subjectError: undefined,
          contentError: undefined,
          postError: undefined,
          hasFocus: false,
          urlLinks: undefined,
          fields: [],
          mentions: []
        })
        dispatch(actions.clearUrlInfo(nextProps.componentId))
        dispatch(actions.clearUploadFilesAndVideos(nextProps.componentId))
        dispatch(actions.clearSavedDiary())
        dispatch(actions.fetchSavedDiaries(nextProps.group.group_id, nextProps.user.user_id))
        dispatch(actions.fetchDiaryKpi(nextProps.group.group_id, new Date()))
        dispatch(actions.fetchDiaryTemplates(nextProps.group.group_id, nextProps.user.user_id))

        if (props.rightSidePageIsGoogleCalendar)
          dispatch(actions.closeRightSidePage())
      }

      // 一時保存処理ができたタイミングでui.saveMessageをtrueにする
      if(!props.isSaving && nextProps.isSaving && !nextProps.ui.saveMessage) {
        nextProps.updateUI({ saveMessage: true })
        setTimeout(()=> nextProps.updateUI({ saveMessage: false }), 5000)
      }

      // 投稿や一時保存でエラーが発生した
      if (!props.isPostFailed && nextProps.isPostFailed || !props.isSaveFailed && nextProps.isSaveFailed) {
        nextProps.updateUI({ postError: true })
      }

      // 投稿や一時保存のエラーが解消した
      if (props.isPostFailed && !nextProps.isPostFailed || props.isSaveFailed && !nextProps.isSaveFailed) {
        nextProps.updateUI({ postError: undefined })
      }

      // reported_atが変更された
      if (!moment(props.ui.reported_at).isSame(nextProps.ui.reported_at, 'date')) {
        dispatch(actions.fetchDiaryTemplates(nextProps.group.group_id, nextProps.user.user_id))
        dispatch(actions.fetchDiaryKpi(nextProps.group.group_id, nextProps.ui.reported_at))
      }

      // KPIが更新された（編集中でない場合は値を更新）
      if (!nextProps.current && props.kpi !== nextProps.kpi) {
        var values = {}
        var total_values = {}
        each(nextProps.kpi, (item)=> {
          values[(item.kpi_id).toString()] = item.actual ? item.actual : '0'
          total_values[(item.kpi_id).toString()] = item.total ? item.total : '0'
        })
        nextProps.updateUI({ values, total_values })
      }

      // subject, category, fields, 添付ファイルのいずれかが変更された
      if (nextProps.current && (
          props.ui.subject != nextProps.ui.subject ||
          props.ui.category != nextProps.ui.category ||
          isUploadedFilesChanged(props.uploadedFiles, nextProps.uploadedFiles, 'file_id') ||
          isUploadedFilesChanged(props.uploadedVideos, nextProps.uploadedVideos, 'video_id') ||
          props.ui.fields && nextProps.ui.fields && props.ui.fields.length == nextProps.ui.fields.length &&
          some(nextProps.ui.fields, (field, i)=> field !== props.ui.fields[i]))) {
        nextProps.onChangeEditor(nextProps)
      }

      // HTMLを挿入する
      if (nextProps.insertHTML && props.insertHTML != nextProps.insertHTML) {
        nextProps.ui.editorHandlers.insertValue(nextProps.insertHTML)
        dispatch(actions.clearInsertDiaryForm())
        nextProps.onChangeEditor(nextProps)
      }

      // 新たに編集対象が読み込まれた
      if (!props.current && nextProps.current && !props.ui.hasFocus && nextProps.ui.editorHandlers ||
          !props.ui.editorHandlers && nextProps.ui.editorHandlers && nextProps.current) {
        nextProps.ui.editorHandlers.insertValue(nextProps.current.content)
        const attach_json = typeof nextProps.current.attach_json == 'string' && JSON.parse(nextProps.current.attach_json) || nextProps.current.attach_json
        // attach_jsonのkpiをvalues, total_valuesに格納する
        var values = {}
        var total_values = {}
        if (nextProps.current.category == 'kpi' && attach_json) {
            each(attach_json.kpi_status, (item)=> {
            values[(item.kpi_id).toString()] = item.actual ? item.actual : '0'
            total_values[(item.kpi_id).toString()] = item.total ? item.total : '0'
          })
        }

        // attach_jsonのlinksをurlLinksに格納する
        var urlLinks = {}
        if (attach_json && attach_json.links)
          urlLinks = attach_json.links

        nextProps.updateUI({
          reported_at: moment(nextProps.current.reported_at).toDate(),
          subject: nextProps.current.subject,
          values: values,
          total_values: total_values,
          category: nextProps.current.category,
          fields: attach_json ? attach_json.fields : [],
          urlLinks: urlLinks,
          mentions: nextProps.current.mention_users
          })

        // 編集時には右サイドページを閉じる
        if (!props.rightSidePageIsCreateDiary) // create_diaryページを表示中の場合はスキップ
          dispatch(actions.closeRightSidePage())

        // 添付ファイルをstoreに読み込む
        each(nextProps.current.files, (file)=> {
          const loadId = Math.random().toString().slice(-12)
          if (file.file_id)
            dispatch(actions.uploadFileCompleted(file, nextProps.componentId, loadId))
          else
            dispatch(actions.uploadVideoCompleted(file, nextProps.componentId, loadId))
        })

        // 本文中のURLでattach_jsonに含まれていないものがあれば情報を取得する
        let match
        while(match = UrlRegex.exec(nextProps.current.content)) {
          let url = match[0]
          if ((!attach_json || !attach_json.links || !attach_json.links[url]) && !isGoogleDocUrl(url))
            dispatch(actions.fetchUrlInfo(url, nextProps.componentId))
        }
      }

      // gapiReadyがtrueになり、linkにファイル名を取得すべきGoogleドキュメントのURLが格納されている
      if (!props.ui.gapiReady && nextProps.ui.gapiReady && nextProps.ui.link) {
        dispatch(actions.fetchGoogleDriveFile(nextProps.ui.link, nextProps.componentId))
      }

      // fetchUrlInfoでリンク先情報を取得した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && !nextProps.urlInfo.isFetchFailed && nextProps.current) {
        var urlLinks = Object.assign({}, nextProps.ui.urlLinks)
        each(nextProps.urlInfo, (v, k)=> {
          if (v && !v.isFetching && v.item && (!props.urlInfo || props.urlInfo[k] !== v.item)) {
            urlLinks[k] = v.item
          }
        })
        nextProps.updateUI({ urlLinks })
      }

      // fetcuUrlInfoでリンク先情報の取得に失敗した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && nextProps.urlInfo.isFetchFailed) {
        nextProps.updateUI({ gapiReady: false })
      }

      // すでに編集中の状態でさらに編集を行おうとした場合
      if (!props.isEditDiaryFetching && nextProps.isEditDiaryFetching && (nextProps.current || nextProps.ui.hasFocus)) {
        dispatch(emitAlertMessage({ message: 'error:別の投稿を編集中です' }, 'error'))
      }
    },

    onChangeCategory: (category, props)=> {
      if (props.current && props.current.status == 'committed') return
      if (category == 'memo')
        props.updateUI({ category })
      else
        props.updateUI({ category, subject: undefined })
    },

    onCancel: (props)=> {
      props.updateUI({ hasFocus: false })
      onChangeEditor.cancel()
    },
    openGoogleCalendarPage: ()=> dispatch(actions.openRightSidePage('google_calendar', {})),

    closeRightSidePage: ()=> dispatch(actions.closeRightSidePage()),

    showKpi: (kpi_id)=> dispatch(actions.openRightSidePage('kpi_chart', { kpi_id, group_id: ownProps.group.group_id })),

    openGroupKPIPanel: ()=> dispatch(actions.openGroupSettingsPage('kpi')),

    showUserTemplatesSetting: ()=> dispatch(actions.openUserSettingsPage('templates')),
    showGroupTemplatesSetting: ()=> ownProps.group.is_admin && dispatch(actions.openGroupSettingsPage('templates')),
    showGoogleDoc:  (url)=> dispatch(actions.openRightSidePage('google_doc', { url: url }, true)),
    showGambaUrl: (url)=> {
      const paths = url.replace(/^.+groups\//, '').split('/')
      var kpi_id, diary_id, chat_room_id, match
      var group_id = parseInt(paths[0])
      if (paths.length == 2 && paths[1] == 'timeline') {
        pushRoute('group_timeline', { group_id })
      }
      else if (paths.length == 1 && paths[0] == 'home') {
        pushRoute('home_group')
      }
      else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3])
        dispatch(actions.openRightSidePage('kpi_chart', { group_id, kpi_id }))
      }
      else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1])
        dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }))
      }
      else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2])
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id }))
      }
    },
    askGpt: (message)=> dispatch(actions.fetchReview(message)),
    onOpenReview: ()=> dispatch(actions.openReviewPanel()),
    onCloseReview: ()=> {
      dispatch(actions.closeReviewPanel())
    },
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state: {
      category: 'diary',
      editorHandlers: undefined,
      subject: '',
      reported_at: undefined,
      subjectError: undefined,
      contentError: undefined,
      postError: undefined,
      hasFocus: false,
      urlLinks: undefined,
      confirmGapi: false,
      link: undefined,
      values: {},
      total_values: {},
      dateValue: undefined,
      timeValue: undefined,
      fields: [],
      mentions: undefined,
      saveMessage: false,
      gapiReady: ()=> window.gapi && window.gapi.client && window.gapi.client.getToken(),
    }
  }),
  context({ showUserSelectionDialog: PropTypes.func }),
  lifecycle,
  windowFocus,
  translate(),
  trackHandlers('validateAndSubmit', 'diary_submit'),
  trackHandlers('askGpt', 'ask_gpt_diary_form'),
)



// WEBPACK FOOTER //
// ./src/connects/diary-form.js